import { render, staticRenderFns } from "./MessageSticker.vue?vue&type=template&id=e7f411b4&"
import script from "./MessageSticker.vue?vue&type=script&lang=js&"
export * from "./MessageSticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports